import { isEqual } from 'bold-ui'
import { SEM_EQUIPE_ITEM } from 'components/form'
import { LotacaoOuEstagio } from 'graphql/types.generated'
import { isObjectDeepEmpty } from 'util/object'
import { isMicroareasFiltrosDefault } from 'view/visualizacaoTerritorial/components/filter/utils-microareasFilter'
import { VisualizacaoMicroareasFilterFormModel } from 'view/visualizacaoTerritorial/model'

import { TerritorioMapaBuscaFormModel } from './model-territorioMapaBusca'

export function isFilterDefault(
  appliedValues: TerritorioMapaBuscaFormModel,
  defaultValues: TerritorioMapaBuscaFormModel
) {
  if (!isMicroareasFiltrosDefault(appliedValues?.filtrosAvancados)) return false

  const isUnidadeSaudeDefault = appliedValues?.unidadeSaude?.id === defaultValues?.unidadeSaude?.id
  const isEquipeDefault = appliedValues?.equipe?.id === defaultValues?.equipe?.id
  const isMicroareasDefault = isEqual(appliedValues?.microareas?.toSorted(), defaultValues?.microareas?.toSorted())

  return isUnidadeSaudeDefault && isEquipeDefault && isMicroareasDefault
}

export function hasFiltrosAvancados(
  values: VisualizacaoMicroareasFilterFormModel | undefined
): values is VisualizacaoMicroareasFilterFormModel {
  return !isObjectDeepEmpty(values ?? {})
}

export function getFilterDefaultValues(acesso: LotacaoOuEstagio): TerritorioMapaBuscaFormModel {
  return {
    unidadeSaude: acesso.unidadeSaude,
    equipe: acesso.equipe ?? SEM_EQUIPE_ITEM,
  }
}
